/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M12 3a9 9 0 1 0 9 9", "key": "svg-0" }]];
const IconLoader2 = createReactComponent("outline", "loader-2", "Loader2", __iconNode);

export { __iconNode, IconLoader2 as default };
//# sourceMappingURL=IconLoader2.mjs.map
